export default {"src":"/_next/static/media/twitch.03027621.svg","height":138,"width":118,"blurWidth":0,"blurHeight":0};